export const environment = {
    production: true,
    apiURL: '/api',
    echoKey: 'XbA64g.Rbaa1A'
};
